<div class="container">
    <div class="row mt-4" [formGroup]="form">
        <div class="col-12">
            <h4>Novo Formulário</h4>
        </div>
        <div class="col-12">
            <hr>
        </div>
        <div class="col-12">
            <label for="">Nome</label>
            <input type="text" class="form-control" formControlName="name">
        </div>
        <div class="col-12 mt-2">
            <label for="">Descrição</label>
            <textarea class="form-control" cols="30" rows="5" formControlName="description"></textarea>
        </div>

        <div class="col-6 mt-4 text-left">
            <button class="btn btn-secondary col-6" (click)="backList()">Voltar</button>
        </div>
        <div class="col-6 mt-4 text-right">
            <button class="btn btn-success col-6" (click)="saveUpdate()">Gravar</button>
        </div>


    </div>
</div>